import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGasHolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 95,
	viewBox: "0 0 70.0 95.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 30.0 L 0.0 95.0 L 70.0 95.0 L 70.0 30.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 5.0 55.0 L 5.0 15.0 A 30.0 15.0 0.0 1 1 65.0 15.0 L 65.0 55.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgGasHolder;
